import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  Profile,
  AuthService,
  ProfileService,
  AppInsightsService,
  EnvironmentModel,
  EnvironmentType
} from 'common';
import { MENU_ITEMS } from './menu/menu-items';
import { AuthServiceOptions } from '@common/generic/models/AuthServiceOptions';
import { HttpClient } from '@angular/common/http';
import {NavigationEnd, Router, ActivatedRoute} from '@angular/router';
import {log} from 'util';
import {KeycloakService} from 'keycloak-angular';
import {UrlService} from './participants/services/urlService';
import { filter, map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  profile: Profile;
  menuItems = MENU_ITEMS;
  environmentName: EnvironmentType;
  private options: AuthServiceOptions;
  previousUrl: string = null;
  currentUrl: string = null;
  constructor(
    private auth: AuthService,
    private profileService: ProfileService,
    // Tracking is not properly enabled without injecting this service
    private appInsightsService: AppInsightsService,
    private changeDetectorRef: ChangeDetectorRef,
    private config: EnvironmentModel,
    private router: Router,
    private http: HttpClient,
    private keycloak: KeycloakService,
    private urlService: UrlService,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
  ) {
    /*appInsights.queue.push(() => {
      appInsights.context.addTelemetryInitializer(envelope => {
        envelope.tags['ai.cloud.role'] = 'so.spa';
      });
    });*/
    this.options = new AuthServiceOptions(this.config);
    this.environmentName = this.config.environmentType;
    this.auth.registerReload(this);
  }

  ngOnInit() {
     if (!this.auth.isLoggedIn()) {
       this.profileService.clear();
     }
     this.profileService.currentProfile.subscribe(p => {
       this.profile = p;
       this.changeDetectorRef.detectChanges();
     });
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.urlService.setPreviousUrl(this.previousUrl);
    });
    this.titleService.setTitle('iSHARE ' + this.profile.configPartyName);
    // const appTitle = this.titleService.getTitle();
    // this.router
    //   .events.pipe(
    //   filter(event => event instanceof NavigationEnd),
    //   map(() => {
    //     const child = this.activatedRoute.firstChild;
    //     if (child.snapshot.data['title']) {
    //       return child.snapshot.data['title'];
    //     }
    //     console.log(appTitle);
    //     return appTitle;
    //   })
    // ).subscribe((ttl: string) => {
    //   this.titleService.setTitle(ttl);
    //   console.log(ttl);
    // });
    /*this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        if (e.url !== '/account/login') {
         /!* this.profile = new class implements Profile {
            email = this.profile.partyName;
            id = 'a12345678910';
            partyId = 'a1234';
            partyName = 'ishareadmin';
            role = 'SchemeOwner';
          };*!/
        }
      }
    });*/
  }

  logout() {
    this.keycloak.logout();
    // this.http
    //   .post<any>(this.options.logoutEndpoint, JSON.stringify(this.auth.getRefreshToken()))
    //   .subscribe(() => {
    //     this.auth.triggerRefresh();
    //     this.auth.clearLogout();
    //     this.auth.goToLoginPage();
    //   });
  }

  goToProfile() {
    this.router.navigate(['account', 'profile']);
  }

}
